import { defineStore } from 'pinia';
import axios from 'axios';

export const useRotationalSpecialBannersStore = defineStore('rotationalspecialbanner', {
  state: () => ({
    buttonsData: [],
    fetching: null
  }),

  actions: {
   fetchCTASettings() {
      if (this.buttonsData.length > 0) return this.buttonsData;

      if (this.fetching) return this.fetching;

      this.fetching = axios
        .get(`${window.ApiBaseUrl}/Inventory/GetSpecialCtaSettings?campaignId=${window.campaignId}`)
        .then(res => {
          this.buttonsData = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          console.error('[CTA Fetch Error]', err);
        })
        .finally(() => {
          this.fetching = null;
        });
    }
  },

  getters: {
    getButtons: state => state.buttonsData
  }
});
